import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as types from './types';


export const initialize = createAction(types.INITIALIZE);
export const cleanup = createAction(types.CLEANUP);
export const toggleTeamSelection = createAction(types.TOGGLE_TEAM_SELECTION);

export const getGroup = createApiAction(
  types.GROUP_GET,
  (payload) => api.getGroup(payload),
);

export const updateGroup = createApiAction(
  types.GROUP_UPDATE,
  (payload) => api.updateGroup(payload.id, payload),
);

export const setGroupConcurrency = createApiAction(
  types.GROUP_SET_CONCURRENCY,
  (payload) => {
    const { groupId, ...data } = payload;
    return api.setGroupConcurrency(groupId, data);
  },
);

export const removeTeamFromGroup = createApiAction(
  types.TEAM_REMOVE_FROM_GROUP,
  ({ groupId, teamId }) => api.removeTeamFromGroup(teamId, groupId)
    .then(() => ({ groupId, teamId }))
    .catch((err) => {
      /* eslint-disable no-param-reassign */
      err.groupId = groupId;
      err.teamId = teamId;
      throw err;
    }),
);

export const getGroupTeamsUsageCSV = createApiAction(
  types.GET_GROUP_TEAMS_USAGE_CSV,
  (payload, meta, dispatch) => (
    api.getGroupTeamsUsageCSV(payload)
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);
